import { api } from '@api'
import { Scope } from '@utils'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'

export type KeepContact = {
  id: string
  name: string
  description?: string
  contactAccountId: string
  keepDate: string
  date: string
  time: string
  rrule?: string | null
  location?: { place: string; city?: string; country?: string; state?: string; region?: string } | null
  hasReminder?: boolean
  scope: string
  contact: {
    firstName: string
    lastName: string
    avatarUrl: string
    fullName: string
  }
  createdAt: string
  updatedAt: string
}

// Per request: the screens load every page (grouped by period, counted), so
// fewer round trips than the API's 10.
const PAGE_SIZE = 100

const fetchKeepContacts = async ({ pageParam = '0', search, scope, moment, contactAccountId, hashtagIds, categoryIds }: FetchParams): Promise<PaginatedResponse<KeepContact>> => {
  let url = `/keep-contacts?page=${pageParam}&limit=${PAGE_SIZE}`
  if (search) url += `&search=${search}`
  if (scope) url += `&scope=${scope}`
  if (moment) url += `&moment=${moment}`
  if (contactAccountId) url += `&contactAccountId=${encodeURIComponent(contactAccountId)}`
  if (hashtagIds?.length) url += `&hashtagIds=${hashtagIds.join(',')}`
  if (categoryIds?.length) url += `&categoryIds=${categoryIds.join(',')}`

  const { data } = await api.get<PaginatedResponse<KeepContact>>(url)
  return data
}

export const usePaginateKeepContacts = ({ search, scope, moment, contactAccountId, hashtagIds, categoryIds }: { search?: string, scope?: Scope, moment?: 'today' | 'week' | 'month' | 'later'; contactAccountId?: string; hashtagIds?: string[]; categoryIds?: string[] } = {}) => {
  return usePaginate<KeepContact>('keep-contacts', fetchKeepContacts, { search, scope, moment, contactAccountId, hashtagIds, categoryIds })
}

